export * from './WalletConnectConnector.js';
//# sourceMappingURL=index.js.map